var _defs, _g, _g2, _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpiritualTaraNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400.24 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.95,171.05c2.41,0,2.42-3.75,0-3.75s-2.42,3.75,0,3.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.56,160.06c4.34,0,4.35-6.75,0-6.75s-4.35,6.75,0,6.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.17,149.07c6.27,0,6.28-9.75,0-9.75s-6.28,9.75,0,9.75h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.49,66.64l40.56,70.26h-81.13s40.56-70.26,40.56-70.26M296.49,60.64l-2.6,4.5-40.56,70.26-2.6,4.5h86.33s5.2,0,5.2,0l-2.6-4.5-40.56-70.26-2.6-4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.05,87.88l-40.56,70.26-40.56-70.26h81.13M342.25,84.88h-91.52l2.6,4.5,40.56,70.26,2.6,4.5,2.6-4.5,40.56-70.26,2.6-4.5h0Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 200.12,
    cy: 375.5,
    r: 20.52
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 296.49,
    cy: 112.39,
    r: 12.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.13,178.39c-65.77,38.1-114.76,109.39-103.04,187.48,7.51,61.51,58.37,115.31,120.48,122.19,48.78,5.73,98.98-19.05,119.95-64.2,27-56.19-3.75-129.32-68.07-138.54-36.5-5.87-73.08,10.9-88.41,45.3-4.93,10.81-7.4,22.78-6.51,34.52,1.81,35.18,39.84,66.72,75.02,55.57,23.7-6.68,39.62-30.84,32.37-55.15-5.15-19.24-28.05-31.05-46.7-23.94-16.08,6.09-24.89,26.66-17.55,42.42,0,0-.72.36-.72.36-6.63-13.29-1.99-30.36,9.15-39.75,8.73-7.49,21.33-9.17,32.17-5.99,12.56,3.44,23.12,13.33,26.92,25.85,6.15,18.71-1.17,40.38-17.03,51.92-34.08,25.8-80.65,5.45-95.5-31.94-12.22-30.6.68-66.75,25.21-87.39,19.8-16.89,47.22-23.04,72.68-19.24,54.65,7.51,88.9,58.88,84.33,112.24-2.18,25.81-14.32,50.26-32.26,68.76-46.92,48.54-124.91,48.47-176.03,6.39-63.14-49.11-72.52-143.8-30.35-209.49,13.65-21.78,31.32-40.92,51.37-56.96,10.05-7.99,20.78-15.16,32.15-21.13,0,0,.37.71.37.71h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiritualTaraNew);
export default __webpack_public_path__ + "static/media/Spiritual-Tara-New.3bc39c97818ef9ace198f29b421bedaf.svg";
export { ForwardRef as ReactComponent };